const searchData = [
  { address: "/", title: "ГЛАВНАЯ" },
  { address: "/policy", title: "ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ" },
  { address: "/blog", title: "БЛОГ" },
  { address: "/reviews", title: "ОТЗЫВЫ" },
  { address: "/company", title: "О КОМПАНИИ" },
  { address: "/services", title: "УСЛУГИ" },
  { address: "/services/talkitout", title: "ВЫГОВОРИТЬСЯ" },
  { address: "/services/career-consult", title: "КАРЬЕРНАЯ КОНСУЛЬТАЦИЯ" },
  { address: "/services/vacancies", title: "Ведение вакансий" },
  { address: "/services/search-support", title: "СОПРОВОЖДЕНИЕ ПОИСКА РАБОТЫ" },
  { address: "/services/probation-support", title: "СОПРОВОЖДЕНИЕ ИСПЫТАТЕЛЬНОГО СРОКА" },
  { address: "/services/it-hiring", title: "ПОДБОР ИТ СПЕЦИАЛИСТОВ" },
  { address: "/services/it-training", title: "ОБУЧЕНИЕ ПРОФЕССИИ ИТ РЕКРУТЕР" },
  { address: "/services/linkedin-boost", title: "РАЗВИТИЕ LINKEDIN ПРОФИЛЯ" },
  { address: "/services/cv-ready", title: "РЕЗЮМЕ \u00abПОД КЛЮЧ\u00bb" },
];

export default searchData;
